/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { fetchWithOAuth2Credentials } from '../../credentials_provider/oauth2';
import { uncancelableToken } from '../../util/cancellation';
import { responseArrayBuffer, responseJson } from '../../util/http_request';
/**
 * Key used for retrieving the CredentialsProvider from a CredentialsManager.
 */
export const credentialsKey = 'google-brainmaps';
export function makeRequest(instance, credentialsProvider, httpCall, cancellationToken = uncancelableToken) {
  return fetchWithOAuth2Credentials(credentialsProvider, `${instance.serverUrl}${httpCall.path}`, { method: httpCall.method, body: httpCall.payload }, httpCall.responseType === 'json' ? responseJson : responseArrayBuffer, cancellationToken);
}
//# sourceMappingURL=api.js.map